import React, { Suspense, lazy, useEffect } from 'react';
import Hero from "../hero/Hero";
import Article from "../article/Article"
import { FaRegFilePdf } from "react-icons/fa";
import { Helmet } from "react-helmet";
import Placeholder from '../generic/Placeholder'


const Features = lazy(() => import("../features/Features"))
const Pricing = lazy(() => import("../pricing/Pricingoffice365"))
const ContactForm = lazy(() => import("../contact-form/ContactForm"))
const QuestionsAndAnswers = lazy(() => import("../questions-and-answers/QuestionsAndAnswers"))
const Resources = lazy(() => import("../resources/Resources"))
const Presentations = lazy(() => import("../presentations/Presentations"))

const resourcesList = [
    {
        icon: <FaRegFilePdf/>,
        title: "Mailwall Email Filtering Brochure",
        source: "resources/downloads/Mailwall-Email-Filtering-Brochure.pdf",
    },
    {
        icon: <FaRegFilePdf/>,
        title: "Mailwall Email Filtering User Guide",
        source: "resources/downloads/Mailwall-Email-Filtering-Remote-User-Guide.pdf",
    }
]


const PageMailwallOffice365 = () => {
    return (
        <>
            <Helmet>
                <title>Mailwall - Office365 Protection</title>
                <meta name="description" content="Mailwall - advanced email filtering services for business. See how Omniquad's email protection can meet all your online security needs."/>
            </Helmet>

            <main className={"Page"}>
                <Hero showButtons mailwallTrial>
                    <h1>Mailwall Advanced Email Threat Protection For Office 365</h1>
                    <p>Omniquad provides email security, continuity and archiving for Office 365. Our solution enables you to quickly establish and maintain a strong level of protection, compliance and governance. Omniquad allows you to manage defence in depth for Office 365 in one place and reduce operational overheads. </p>
                    <p>Detect and prevent:<br/>Phishing attacks where the identity of users is spoofed 
targeted spear-phishing and whaling attacks 
supply chain attacks - Business Email Compromise and impersonation attempts - malware, viruses, and ransomware 
fraud</p>
                    <p>Analysis:<br/>
                     Deep content inspection<br/>
                     Sandbox analysis and preview
                    </p>
                </Hero>
                <Article>
                    <Suspense fallback={<Placeholder />}>
                        <Features dataFile="featuresOffice365Data.js" />
                    </Suspense>
                </Article>
            </main>
            <Suspense fallback={<Placeholder />}>
                <ContactForm variant={"mailwall"} />
                <QuestionsAndAnswers/>
                <Resources resourcesList={resourcesList}/>
                <Presentations/>
            </Suspense>
        </>
    )
}

export default PageMailwallOffice365;
